import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Revisione53State } from '../../../store/revisione53.reducers';
import { getControl } from '@shared/helpers/form.helper';
import { withInitialValueDebounced } from '@shared/operators/with-initial-value-debounced.operator';
import { getConclusioniControl } from '../validators/helpers/conclusioni-form.helper';
import { calcolaDataScadenzaAccertamento, calcolaDataScadenzaDiffida } from './helpers/conclusioni-listeners.helper';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { differenceInCalendarDays } from 'date-fns';
import { updateVerbaleOnStore } from '@core/helpers/create-validator.helper';
import { MyVerbale } from '../../../models/interfaces/revisione.interface';
import { cloneDeep } from 'lodash-es';

export const setConclusioniScadenzeListeners = (form: FormGroup, store: Store<Revisione53State>): void => {
    my_DataCompilaz(form, store);
    my_ggDiffida(form, store);
};

const my_DataCompilaz = (form: FormGroup, store: Store<Revisione53State>): void => {
    const control = getConclusioniControl(form, 'my_DataCompilaz');

    control.valueChanges.pipe(withInitialValueDebounced(control)).subscribe(() => {
        calcolaGiorniDurataRevisione(form, store);
        calcolaDataScadenzaDiffida(form, store);
    });
};

const my_ggDiffida = (form: FormGroup, store: Store<Revisione53State>): void => {
    const control = getConclusioniControl(form, 'my_ggDiffida');
    control.valueChanges.pipe(withInitialValueDebounced(control)).subscribe(() => {
        calcolaDataScadenzaDiffida(form, store);
        calcolaDataScadenzaAccertamento(form, store);
    });
};

const calcolaGiorniDurataRevisione = (form: FormGroup, store: Store<Revisione53State>): void => {
    const dataInizioControl = getControl(form, 'my_SezioneI__Rilevazione.my_DatiIdentificativi.my_DataRevisioneDal');

    const dataFineControl = getConclusioniControl(form, 'my_DataCompilaz');
    const giorniDurataRevisioneControl = getControl(form, 'my_SezioneI__Rilevazione.my_DatiIdentificativi.my_GiorniDurataRevisione');
    const dataInizioRaw = dataInizioControl.value;
    const dataFineRaw = dataFineControl.value;

    let giorniDurata = '';

    if (!isNilOrEmpty(dataInizioRaw) && !isNilOrEmpty(dataFineRaw)) {
        const dataInizio = new Date(dataInizioRaw);
        const dataFine = new Date(dataFineRaw);

        if (!isNaN(dataInizio.getTime()) && !isNaN(dataFine.getTime())) {
            giorniDurata = differenceInCalendarDays(dataFine, dataInizio).toString(10);
        }
    }

    giorniDurataRevisioneControl.patchValue(giorniDurata, {
        emitEvent: false,
    });

    updateVerbaleOnStore(store, (myVerbale) => {
        const myVerbaleClone: MyVerbale = cloneDeep(myVerbale);

        myVerbaleClone.my_SezioneI__Rilevazione.my_DatiIdentificativi.my_GiorniDurataRevisione = giorniDurata;

        return myVerbaleClone;
    });
};
